export default __webpack_public_path__ + "static/media/atuacao_img_1.33c9ca0b.svg";